import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeftOutlined, CheckCircleOutlined } from "@ant-design/icons";
import { Button, Typography } from "antd";
import { useCurrentApplication } from "../../../Context/CurrentApplicationContext/CurrentApplicationContext";

const JobPostDetails: React.FC = () => {
  const navigate = useNavigate();
  const { jobPost } = useCurrentApplication();

  const handleBack = () => {
    navigate("/", { replace: true });
  };

  if (!jobPost) {
    return null;
  }

  const { title, position, description, requirements } = jobPost;
  return (
    <div className="job-posts-details__card">
      <div className="job-posts-details__card-header">
        <div className="job-posts-details__job-title-header">
          <Button
            type="text"
            onClick={handleBack}
            icon={<ArrowLeftOutlined />}
          />
          <Typography.Title level={4} style={{ margin: 0 }}>
            {title}
          </Typography.Title>
        </div>
        <span className="job-posts-details__badge">{position}</span>
      </div>

      <section className="job-posts-details__section">
        <div className="job-posts-details__section-title">
          <span className="job-posts-details__section-bar" />
          <Typography.Title level={5} style={{ margin: 0 }}>
            About the job
          </Typography.Title>
        </div>
        <Typography.Paragraph style={{ margin: 0 }} type="secondary">
          {description}
        </Typography.Paragraph>
      </section>

      <section className="job-posts-details__section">
        <div className="job-posts-details__section-title">
          <span className="job-posts-details__section-bar" />
          <Typography.Title level={5} style={{ margin: 0 }}>
            Job Requirements
          </Typography.Title>
        </div>
        <div className="job-posts-details__requirements-grid">
          {requirements.map((requirement, index) => (
            <div className="job-posts-details__requirement-item" key={index}>
              <CheckCircleOutlined className="job-posts-details__requirement-icon" />
              <Typography.Text style={{ margin: 0 }}>
                {requirement.description}
              </Typography.Text>
            </div>
          ))}
        </div>
      </section>

      {/* <section className="job-posts-details__manager">
          <h3 className="job-posts-details__manager-title">
            <TeamOutlined className="job-posts-details__manager-title-icon" />
            Meet your Manager
          </h3>
          <div className="job-posts-details__manager-content">
            <img
              alt="Sarah - Engineering Manager"
              className="job-posts-details__manager-avatar"
              src="https://lh3.googleusercontent.com/aida-public/AB6AXuBY7_PiX_ay2B84fN_kM2igymuS2-YZLecaxIdKPsL-5u_NkpKun36ZuSGEu4yetrAKSJj8qzwWJLvKgsRslq6dJFhEA_Dbo8OT9f-_PBTTNJFmAXCPyxNnxkCi_ysf3ZeQit9HCbzUvOqe71KP-3Z_dW5hfxzKuDc5I2HM-75bD8FmFGmKG9nwjuWazfRtwpXj2jqr0GsCnc0A1yEsoMnkd0DM-w-1GR_gXJADLPkXWxOwiBVXM5mU8gkk-_wHVraR_2FDo_N5T19w"
            />
            <div>
              <p className="job-posts-details__manager-name">Sarah Jenkins</p>
              <p className="job-posts-details__manager-role">
                Engineering Manager @ CreditOrg
              </p>
              <p className="job-posts-details__manager-quote">
                &quot;We value curiosity over pure experience for this
                role.&quot;
              </p>
            </div>
          </div>
        </section> */}
    </div>
  );
};

export default JobPostDetails;
